import ModalDialog from './modal-dialog-view'

export default ModalDialog
